// extracted by css-extract-rspack-plugin
export default {"repeater":"TypO4","wrapper":"wngi8"};